import type { Order } from '@seen/core/models/orders/Order'
import { resolveId } from '@seen/core/references'
import { Button, TypographyDetail } from '@seen/ui'
import { IconLink } from '@tabler/icons-react'
import { type JSX, useContext } from 'react'
import { toast } from 'sonner'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'
import { OrderMention } from '#src/components/OrderMention.tsx'
import { ConfigContext } from '#src/contexts/config/ConfigContext.tsx'

export function OrderCreatedToast({ order }: { order: Order }): JSX.Element {
  const url = `/Patient/${resolveId(order.participant)}/orders/${order.id}`
  const origin = useContext(ConfigContext)?.portalOrigin

  return (
    <div className="flex min-w-0 flex-1 flex-col gap-2">
      <TypographyDetail>Order created</TypographyDetail>
      <div className="flex flex-col">
        <div className="flex">
          <OrderMention order={order.reference} className="truncate" />
        </div>
        <div className="flex items-center justify-between gap-2">
          <TextLink to={url}>View order</TextLink>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => {
                  void navigator.clipboard.writeText(
                    new URL(url, origin ?? window.location.origin).href
                  )
                  toast.info('Order URL copied to clipboard')
                }}
              >
                <IconLink className="size-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent side="top" align="center" className="z-toast">
              Copy order URL
            </TooltipContent>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}
